import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { CompanyServiceRanking } from 'src/app/interfaces/models/company-service-ranking';

import { BaseModel } from './base-model';
import { CompanyVendor } from './company-vendor';

export class VendorRanking extends BaseModel {
  static VendorRankingProperties: (
    | {
        property: keyof VendorRanking;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof VendorRanking;
        type: 'alias';
      }
    | {
        property: keyof VendorRanking;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'CompanyServiceRankingId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'tradeCategoryName', type: 'column', dataType: 'string' },
    { property: 'tradeName', type: 'column', dataType: 'string' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    { property: 'exemptVendorTypeName', type: 'column', dataType: 'string' },

    {
      property: 'CompanyServiceRanking',
      model: 'CompanyServiceRanking',
      type: 'association'
    },
    {
      property: 'CompanyVendorFull',
      model: 'CompanyVendorFull',
      type: 'association'
    },
    {
      property: 'CompanyVendorExempt',
      model: 'CompanyVendorExempt',
      type: 'association'
    }
  ];

  static {
    VendorRanking.VendorRankingProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        VendorRanking.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        VendorRanking.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        VendorRanking.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(VendorRankingObject: Partial<VendorRanking>) {
    super();

    VendorRanking.VendorRankingProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = VendorRankingObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  VendorId?: number | null;
  CompanyId?: number;
  CompanyServiceRankingId?: number;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  tradeCategoryName?: string | null;
  tradeName?: string | null;
  ExemptVendorId?: number | null;
  exemptVendorTypeName?: string | null;

  CompanyServiceRanking?: CompanyServiceRanking;
  CompanyVendorExempt?: CompanyVendor;
  CompanyVendorFull?: CompanyVendor;
}
